import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import './styles/global.css';
import AppShell from './components/layout/AppShell';
import LoginPage from './pages/auth/LoginPage';
import ChangePasswordPage from './pages/auth/ChangePasswordPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import RolesPage from './pages/roles/RolesPage';
import UsersPage from './pages/users/UsersPage';
import { AcademicYearsPage, DistrictsPage, PincodesPage } from './pages/masters/MastersPages';
import TutorialsPage from './pages/tutorials/TutorialsPage';
import ChaptersPage from './pages/tutorials/ChaptersPage';
import { CreatorVideosPage, BlogVideosPage } from './pages/videos/VideosPages';
import BatchesPage from './pages/batches/BatchesPage';
import SchoolsPage from './pages/schools/SchoolsPage';
import OrdersPage from './pages/orders/OrdersPage';
import DirectCodesPage from './pages/codes/DirectCodesPage';
import RedemptionReportPage from './pages/reports/RedemptionReportPage'; // ← NEW
import EndUsersPage from './pages/users/EndUsersPage';   // ← import
import SchoolUsersPage from './pages/schools/SchoolUsersPage';

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'var(--orange-50)'}}><div className="loader"/></div>;
  return user ? children : <Navigate to="/login" replace />;
};
const RequireGuest = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/dashboard" replace /> : children;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{
          style:{ fontFamily:'DM Sans,sans-serif', fontSize:'13.5px', borderRadius:'8px', border:'1px solid var(--orange-200)' },
          success:{ iconTheme:{ primary:'var(--orange-400)', secondary:'white' } }
        }}/>
        <Routes>
          <Route path="/login"           element={<RequireGuest><LoginPage/></RequireGuest>} />
          <Route path="/change-password" element={<RequireAuth><ChangePasswordPage/></RequireAuth>} />
          <Route path="/" element={<RequireAuth><AppShell/></RequireAuth>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard"      element={<DashboardPage/>} />
            <Route path="tutorials"      element={<TutorialsPage/>} />
            <Route path="tutorials/:tutorialId/chapters" element={<ChaptersPage/>} />
            <Route path="creator-videos" element={<CreatorVideosPage/>} />
            <Route path="blog-videos"    element={<BlogVideosPage/>} />
            <Route path="batches"        element={<BatchesPage/>} />
            <Route path="schools"        element={<SchoolsPage/>} />
            <Route path="orders"         element={<OrdersPage/>} />
            <Route path="direct-codes"   element={<DirectCodesPage/>} />
            <Route path="redemption-report" element={<RedemptionReportPage/>} /> {/* ← NEW */}
            <Route path="school-users"   element={<SchoolUsersPage/>} />          {/* ← NEW */}
            <Route path="end-users" element={<EndUsersPage/>} /> 
            <Route path="users"          element={<UsersPage/>} />
            <Route path="roles"          element={<RolesPage/>} />
            <Route path="masters/academic-years" element={<AcademicYearsPage/>} />
            <Route path="masters/districts"      element={<DistrictsPage/>} />
            <Route path="masters/pincodes"       element={<PincodesPage/>} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
